module.exports = __webpack_public_path__ + "static/criminal-d20c34a816c25d2ce89d5b5329359159.webp";